import type { Filter } from "@/models/ListRequest";
import type { FilterRecipesNames } from "@/models/Recipes/FilterRecipesNames";
import type { Recipe } from "@/models/Recipes/Recipe";

export function buildRecipeListingFilters(
  selectedCategoryId?: number | null,
  activeFilter?: Filter | null,
): Filter[] {
  const filters: Filter[] = [];

  if (selectedCategoryId) {
    filters.push({
      name: "RecipeCategoryId",
      value: String(selectedCategoryId),
    });
  }

  if (
    activeFilter?.name
    && activeFilter.value !== undefined
    && activeFilter.value !== null
    && String(activeFilter.value) !== ""
    && !(activeFilter.name === "RecipeCategoryId" && String(activeFilter.value) === String(selectedCategoryId || ""))
  ) {
    filters.push(activeFilter);
  }

  return filters;
}

export function filterRecipeSearchResultsByCategory(
  results: FilterRecipesNames[] = [],
  selectedCategoryId?: number | null,
): FilterRecipesNames[] {
  if (!selectedCategoryId) {
    return results;
  }

  return results.filter((category) => Number(category.id) === Number(selectedCategoryId));
}

export function collectRecipesFromCategoryResults(
  results: FilterRecipesNames[] = [],
  selectedCategoryId?: number | null,
): Recipe[] {
  return filterRecipeSearchResultsByCategory(results, selectedCategoryId)
    .flatMap((category) => category.recipes || []);
}